module.exports = __webpack_public_path__ + "media/images/emblems/Ecubasseallaine-bbc249530c23402723b61fe89b923ee3.png";